import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  API_ciudadanos,
  API_empleos,
  API_recursos,
  API_cursos,
} from "../../config/apiConfig";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import {
  FaCalendarDays,
  FaEnvelope,
  FaX,
  FaFilePdf,
  FaCircleQuestion,
} from "react-icons/fa6";
import Navbar from "../../components/Navbar";
import NuevoMensaje from "../../components/dashboard_ciudadano/NuevoMensaje";
import Cita from "../../components/dashboard_ciudadano/CitaERACIS";
import HistorialCitas from "../../components/dashboard_ciudadano/HistorialCitas";
import DatosContacto from "../../components/dashboard_ciudadano/DatosContacto";
import Destacados from "../../components/dashboard_ciudadano/Destacados";
import "./css/Dashboard.css";
import { useAuth } from "../../context/AuthContext";

const UserDashboard = () => {
  // ESTADO GLOBAL (redux)
  const { user } = useSelector((state) => state.auth); // Obtener usuario logueado
  const { token } = useAuth();

  // Estados del usuario logueado
  const [nombreUsuario, setNombreUsuario] = useState("");
  const [fotoPerfil, setFotoPerfil] = useState("");
  const fotoPerfilDefault =
    "https://w7.pngwing.com/pngs/915/511/png-transparent-female-avatar-girl-face-woman-user-flat-classy-users-icon.png";
  const [progreso, setProgreso] = useState(40); // valor inicial del progreso
  const [datosUsuario, setDatosUsuario] = useState(null); // Datos completos del ciudadano

  //Ventana emergente con formulario Nuevo mensaje
  const [nuevoMensaje, setNuevoMensaje] = useState(false);
  const [mensajeEnviado, setMensajeEnviado] = useState(false);
  const [formMensaje, setFormMensaje] = useState({
    servicio: "",
    asunto: "",
    mensaje: "",
  });

  const handleChange = (e) => {
    setFormMensaje((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Aquí puedes hacer el fetch o enviar el mensaje por API
    setNuevoMensaje(false); // cerrar el modal después de enviar
    setMensajeEnviado(true); // mostrar mensaje de éxito
    // Ocultar automáticamente el mensaje después de unos segundos
    setTimeout(() => setMensajeEnviado(false), 5000);
  };

  // CITAS que tiene el usuario
  const [citas, setCitas] = useState({ futuras: [], pasadas: [] });
  const [historialCitas, setHistorialCitas] = useState(false);

  // Ventana emergente con estados del formulario para pedir cita (Simple)
  const [solicitarCita, setSolicitarCita] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [subject, setSubject] = useState("");
  const [mensajeCitaGeneral, setMensajeCitaGeneral] = useState(false);
  // Ventana emergente con estados del formulario para pedir cita (SS y ERACIS)
  const [mostrarCitaSS, setMostrarCitaSS] = useState(false);

  // Ventana emergente con datos de contacto
  const [datosContacto, setDatosContacto] = useState(false);

  // Mostrar fecha en formato DD/MM/AAAA
  const formatearFecha = (isoDate) => {
    const fecha = new Date(isoDate);
    const dia = String(fecha.getDate()).padStart(2, "0");
    const mes = String(fecha.getMonth() + 1).padStart(2, "0");
    const año = fecha.getFullYear();
    return `${dia}/${mes}/${año}`;
  };

  // Destacados
  const [categoria, setCategoria] = useState("todas");
  const [ofertas, setOfertas] = useState([]);
  const [cursos, setCursos] = useState([]);
  const [recursos, setRecursos] = useState([]);
  const totalNovedades = ofertas.length + recursos.length + cursos.length; // total de novedades (se recalcula en cada render)

  // Fetch destacados
  useEffect(() => {
    const fetchData = async () => {
      try {
        const resEmpleo = await fetch(API_empleos, {
          headers: {
            "x-auth-token": token,
          },
        });
        const dataEmpleo = await resEmpleo.json();
        const destacadosEmpleo = dataEmpleo.filter((item) => item.isFeatured);
        setOfertas(destacadosEmpleo);

        const resRecursos = await fetch(API_recursos);
        const dataRecursos = await resRecursos.json();
        const destacadosRecursos = dataRecursos.filter(
          (item) => item.isFeatured
        );
        setRecursos(destacadosRecursos);

        const resCursos = await fetch(API_cursos, {
          headers: {
            "x-auth-token": token,
          },
        });
        const dataCursos = await resCursos.json();
        const destacadosCursos = dataCursos.filter((item) => item.isFeatured);
        setCursos(destacadosCursos);
      } catch (error) {
        console.error("Error al cargar datos", error);
      }
    };

    fetchData();
  }, []);

  // Fetch Datos del ciudadanos + citas
  useEffect(() => {
    if (!user?.email) return;

    const fetchDatosUsuario = async () => {
      try {
        const res = await fetch(API_ciudadanos, {
          headers: {
            "x-auth-token": token,
          },
        });
        const data = await res.json();

        // Normaliza para evitar problemas de acentos/mayúsculas
        const normalize = (str) =>
          str
            ?.normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase();

        const usuarioEncontrado = data.find(
          (c) =>
            normalize(c.email) === normalize(user.email) ||
            (normalize(c.name) === normalize(user.name) &&
              normalize(c.lastName) === normalize(user.lastName))
        );
        if (!usuarioEncontrado) return;

        setDatosUsuario(usuarioEncontrado);
        setNombreUsuario(usuarioEncontrado.name || "Usuario");
        setFotoPerfil(usuarioEncontrado.profileImageUrl || fotoPerfilDefault);

        // ***** Citas *****
        const citasRes = await fetch(
          `${API_ciudadanos}/${usuarioEncontrado.userId}/citas`,
          {
            headers: {
              "x-auth-token": token,
            },
          }
        );
        const citasData = await citasRes.json();
        const citasAceptadas = citasData.filter(
          (c) => c.state?.toLowerCase() === "aceptado"
        );
        const hoy = new Date();
        hoy.setHours(0, 0, 0, 0);

        const futuras = citasAceptadas
          .filter((c) => new Date(c.appointmentDate) >= hoy)
          .sort(
            (a, b) => new Date(a.appointmentDate) - new Date(b.appointmentDate)
          );
        const pasadas = citasAceptadas
          .filter((c) => new Date(c.appointmentDate) < hoy)
          .sort(
            (a, b) => new Date(b.appointmentDate) - new Date(a.appointmentDate)
          );

        setCitas({ futuras, pasadas });
      } catch (err) {
        console.error("Error datos usuario/citas:", err);
      }
    };

    fetchDatosUsuario();
  }, [user, token]);

  const postCita = async (payload) => {
    try {
      const res = await fetch(`${API_ciudadanos}/${payload.userId}/citas`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "x-auth-token": token },
        body: JSON.stringify(payload),
      });
      if (!res.ok) throw new Error("Error al registrar la cita");
      return true;
    } catch (err) {
      console.error(err);
      alert("Ha ocurrido un error al solicitar la cita. Inténtalo de nuevo.");
      return false;
    }
  };

  const openModalSolicitarCita = () => {
    setSelectedOption("");
    setSubject("");
    setSolicitarCita(true);
  };
  const closeModalSolicitarCita = () => {
    setSolicitarCita(false);
    setSelectedOption("");
    setSubject("");
  };

  const handleSeleccion = (e) => {
    const opcion = e.target.value;
    setSelectedOption(opcion);
    setSubject(""); // resetea asunto al cambiar opción

    if (["Servicios Sociales", "ERACIS"].includes(opcion)) {
      setSolicitarCita(false);
      setMostrarCitaSS(true);
    }
  };

  const handleRequestAppointment = async () => {
    if (!datosUsuario) return;
    if (!subject.trim()) {
      toast.warn("Por favor, rellena el asunto de la cita.");
      return;
    }

    const payload = {
      serviciosSociales: null,
      userId: datosUsuario.userId,
      subject: subject.trim(),
      technicianId: null,
      appointmentDate: null,
      responseMessage: "",
      isResponseRead: false,
      state: "Pendiente",
      name: `${datosUsuario.name} ${datosUsuario.lastName || ""}`.trim(),
      email: datosUsuario.email,
      phone: datosUsuario.phone || "",
      address: datosUsuario.address || "",
      service: selectedOption,
      dni: datosUsuario.dni || "",
    };

    const ok = await postCita(payload);
    if (!ok) return;

    setSolicitarCita(false);
    setMensajeCitaGeneral(true);
    setTimeout(() => setMensajeCitaGeneral(false), 5000);
    closeModalSolicitarCita();
  };

  // Cambiar Foto de perfil
  const handleFotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFotoPerfil(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <>
      <Navbar />

      <main className="dashboard-user column">
        <article className="columna-izquierda between mt-20 mb-30">
          <div>
            <div className="titulo-seccion flex align-end gap-20 mb-10">
              <label className="foto-perfil-label">
                <img
                  src={fotoPerfil || fotoPerfilDefault}
                  alt="Foto de perfil"
                  className="foto-perfil cursor"
                />
                <input
                  type="file"
                  accept="image/*"
                  className="hidden-input"
                  onChange={handleFotoChange}
                />
              </label>
              <div className="column ">
                <h1 className="mayusculas pb-5">
                  ¡Hola<br></br>
                  {nombreUsuario || "Usuario"}!
                </h1>
                <p>
                  Tienes{" "}
                  <span className="bold">{totalNovedades} novedades</span> por
                  ver.
                </p>
                <p>
                  Tienes <span className="bold">X mensajes</span> nuevos.
                </p>
              </div>
            </div>

            {/* Barra porcentaje */}
            <div className="align-center w-100 mb-20">
              {/* Barra gris con la barra completada encima */}
              <div className="relative w-100 barragris">
                <div
                  className="barracompletado fondo-verde"
                  style={{ width: `${progreso}%` }}
                />
              </div>

              {/* Porcentaje a la derecha */}
              <span className="ml-5">{progreso}%</span>
            </div>

            <button
              className="mensaje verde align-center w-100 mb-50"
              onClick={() => setNuevoMensaje(true)}
            >
              <FaEnvelope />
              Enviar nuevo mensaje
            </button>

            {mensajeEnviado && (
              <div className="historico-seguimiento">
                <div className="modal-content mensaje-exito verde mb-30">
                  <p>
                    Mensaje enviado correctamente.<br></br>
                    Uno de nuestros técnicos se pondrá en contacto contigo lo
                    antes posible.
                  </p>
                </div>
              </div>
            )}
          </div>

          {/* Próximas citas */}
          <section className="seccion-citas">
            <div className="titulo-seccion flex mayusculas">
              <FaCalendarDays />
              <h2>
                PRÓXIMAS<br></br>CITAS
              </h2>
            </div>
            <div className="contenido">
              {citas.futuras.length > 0 ? (
                citas.futuras.map((cita, index) => (
                  <p key={index}>
                    <strong>{formatearFecha(cita.appointmentDate)}</strong> -{" "}
                    {cita.service}
                  </p>
                ))
              ) : (
                <p>No tienes próximas citas aceptadas.</p>
              )}
            </div>
            <button className="boton" onClick={() => setSolicitarCita(true)}>
              Solicitar cita
            </button>
            <button
              className="boton ml-5"
              onClick={() => setHistorialCitas(true)}
            >
              Ver historial
            </button>
          </section>

          {/* Repositorio de documentos */}
          <section>
            <div className="titulo-seccion flex mayusculas">
              <FaFilePdf />
              <h2>
                REPOSITORIO DE<br></br>DOCUMENTOS
              </h2>
            </div>
            <div className="contenido">
              <p>
                Consulta tus documentos pdf<br></br>o sube nuevos.
              </p>
            </div>
            <Link to="/documentos" className="boton boton-izq">
              Ver todos los documentos
            </Link>
          </section>

          {/* AYUDA - GUÍA */}
          <section>
            <div className="titulo-seccion flex mayusculas">
              <FaCircleQuestion />
              <h2>
                AYUDA /<br></br>GUÍA
              </h2>
            </div>
            <div className="contenido">
              <p>
                Tenemos un video tutorial <br></br> para que sepas como usar la
                app.
              </p>
            </div>

            <button
              className="boton" /* onClick={() => setSolicitarCita(true)} */
            >
              Ver vídeo
            </button>
            <button
              className="boton ml-5"
              onClick={() => setDatosContacto(true)}
            >
              Datos de contacto
            </button>
          </section>

          {/* Modal de Nuevo mensaje */}
          {nuevoMensaje && (
            <NuevoMensaje
              formMensaje={formMensaje}
              onChange={handleChange}
              onSubmit={handleSubmit}
              onClose={() => setNuevoMensaje(false)}
            />
          )}

          {/* Modal de Solicitar Cita */}
          {/* Modal 1: selección */}
          {solicitarCita && (
            <div className="historico-seguimiento solicita-cita">
              <div className="modal-content">
                <div className="modal-header mayusculas">
                  <h2>Selecciona área de apoyo</h2>
                  <button
                    className="close-button"
                    onClick={() => setSolicitarCita(false)}
                  >
                    <FaX />
                  </button>
                </div>

                <div className="modal-body mt-5">
                  <form className="column gap-5">
                    {[
                      "SAE",
                      "ERACIS",
                      "Andalucía Orienta",
                      "Servicios Sociales",
                      "Punto Vuela",
                    ].map((opcion) => (
                      <label key={opcion} className="align-center gap-5">
                        <input
                          type="radio"
                          name="appointment"
                          value={opcion}
                          onChange={handleSeleccion}
                        />
                        {opcion}
                      </label>
                    ))}

                    {/* Textarea asunto + botón para opciones sencillas */}
                    {selectedOption &&
                      !["Servicios Sociales", "ERACIS"].includes(
                        selectedOption
                      ) && (
                        <>
                          <label className="mt-20 bold">Asunto:</label>
                          <textarea
                            className="campo"
                            placeholder="Asunto de la cita"
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                            required
                          />
                          <button
                            type="button"
                            className="mensaje verde mt-10"
                            onClick={handleRequestAppointment}
                          >
                            Solicitar cita
                          </button>
                        </>
                      )}
                  </form>
                </div>
              </div>
            </div>
          )}

          {mensajeCitaGeneral && (
            <div className="historico-seguimiento">
              <div className="modal-content mensaje-exito verde mb-30">
                <p>
                  Cita solicitada con éxito.<br></br>
                  Uno de nuestros técnicos se pondrá en contacto contigo lo
                  antes posible.
                </p>
              </div>
            </div>
          )}

          {/* Modal 2: formulario Servicios Sociales / ERACIS */}
          {mostrarCitaSS && (
            <div className="modal-overlay">
              <Cita
                onClose={() => setMostrarCitaSS(false)}
                datosUsuario={datosUsuario}
                servicio={selectedOption}
              />
            </div>
          )}

          {/* Modal de Histórico de Seguimiento */}
          {historialCitas && (
            <HistorialCitas
              citasPasadas={citas.pasadas}
              formatearFecha={formatearFecha}
              onClose={() => setHistorialCitas(false)}
            />
          )}

          {/* Modal Datos de contacto */}
          {datosContacto && (
            <DatosContacto onClose={() => setDatosContacto(false)} />
          )}
        </article>

        <Destacados
          categoria={categoria}
          setCategoria={setCategoria}
          ofertas={ofertas}
          recursos={recursos}
          cursos={cursos}
        />
      </main>
    </>
  );
};

export default UserDashboard;
